$(document).ready(function() {
    $('form').one('submit', function () {
        $(this).find('input[type="submit"]:not("[name]")').attr('disabled', 'disabled');
        $(this).find('button[type="submit"]:not("[name]")').attr('disabled', 'disabled');
    });
});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/disable_multy_submit.js